var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pdp__subheader" }, [
    _vm.hasFeatures
      ? _c(
          "div",
          {
            staticClass: "pdp__subheader-item",
            attrs: { "data-id": "section-features", tabindex: "0" },
            on: {
              click: function ($event) {
                return _vm.scrollToSection("#section-features")
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.scrollToSection("#section-features")
              },
            },
          },
          [_vm._v("Features")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasIncludes
      ? _c(
          "div",
          {
            staticClass: "pdp__subheader-item",
            attrs: { "data-id": "section-includes", tabindex: "0" },
            on: {
              click: function ($event) {
                return _vm.scrollToSection("#section-includes")
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.scrollToSection("#section-includes")
              },
            },
          },
          [_vm._v("Includes")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasSpecs
      ? _c(
          "div",
          {
            staticClass: "pdp__subheader-item",
            attrs: { "data-id": "section-specs", tabindex: "0" },
            on: {
              click: function ($event) {
                return _vm.scrollToSection("#section-specs")
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.scrollToSection("#section-specs")
              },
            },
          },
          [_vm._v("Specs")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasManuals
      ? _c(
          "div",
          {
            staticClass: "pdp__subheader-item",
            attrs: { "data-id": "section-manuals", tabindex: "0" },
            on: {
              click: function ($event) {
                return _vm.scrollToSection("#section-manuals")
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.scrollToSection("#section-manuals")
              },
            },
          },
          [_vm._v("Additional Product Information")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasChildproducts
      ? _c(
          "div",
          {
            staticClass: "pdp__subheader-item",
            attrs: { "data-id": "section-product-line", tabindex: "0" },
            on: {
              click: function ($event) {
                return _vm.scrollToSection("#section-product-line")
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.scrollToSection("#section-product-line")
              },
            },
          },
          [_vm._v("Product line")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }